import React, { useState, useEffect, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import aboutImage from '../assets/AboutUs/12.jpeg';
import approvalLetterImage from '../assets/AboutUs/WhatsApp Image 2025-05-04 at 10.03.58.jpeg';
import servicesImage from '../assets/AboutUs/27-Photoroom.png';
import ritaPereraImage from '../assets/AboutUs/WhatsApp Image 2025-05-03 at 17.16.03.jpeg';
import julianTisseraImage from '../assets/AboutUs/6.jpeg';
import judePereraImage from '../assets/AboutUs/WhatsApp Image 2025-05-04 at 10.03.57.jpeg';

const AboutUs = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 992);

    const timelineData = [
        {
            year: "1983",
            text: "Marcsri was born on the 29th January 1983, with the benevolence of Mr. Rita Perera of Kalutara, who opened the doors of her house to a patient whom she has been visiting in the hospital. After the death of her husband Marcus on 5th March 1982, Mrs. Rita began visiting the destitute in hospital that had no one to visit them. The name 'MARCSRI' was the combining of two names 'Marcus'+'Rita', which was the name of their home"
        },
        {
            year: "1989",
            text: "Recognizing Mrs. Rita's efforts, Rev. Fr. Julian Thissera, who was then parish priest of Katukurunda parish in Kalutara became the spiritual guide and helped Mrs. Rita to continue her mission and he joined Marcsri and together they opened several homes."
        },
        {
            year: "2005",
            text: "After Mrs. Rita and Fr. Julian was called to eternal rest, Marcsri Homes continue to fulfill its mission under the Archbishop of Colombo and supervision of Seth Sarana Caritas Colombo"
        }
    ];

    const handleNext = useCallback(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % timelineData.length);
    }, [timelineData.length]);

    const handlePrev = useCallback(() => {
        setActiveIndex((prevIndex) => (prevIndex - 1 + timelineData.length) % timelineData.length);
    }, [timelineData.length]);

    useEffect(() => {
        const interval = setInterval(() => {
            handleNext();
        }, 5000);
        return () => clearInterval(interval);
    }, [handleNext]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            setIsTablet(window.innerWidth >= 768 && window.innerWidth < 992);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="p-lg-10 p-md-5 p-3 text-center">
            <div className="container">
                {/* First Section: Our History */}
                <div className={`row mb-5 ${isMobile ? 'flex-column-reverse' : ''}`} style={{ marginTop: isMobile ? '15px' : '30px' }}>
                    <div className={`${isMobile ? 'col-12' : 'col-md-6'} text-start`}>
                        <h2 className="mb-4" style={{
                            fontSize: isMobile ? '1.8em' : isTablet ? '2.2em' : '2.5em',
                            fontFamily: 'Georgia'
                        }}>
                            Our History and The Development
                        </h2>
                        <p style={{ fontSize: isMobile ? '0.95rem' : '1rem' }}>
                            Marcsri homes started with the benevolence of Mrs Rita Perera of Kalutara. After the death of her husband she was a grieving widow and being childless resorted to works of charity and good works. Her works of charity to the poor and the disabled who came to her for help made her to open her house "Marcsri" (this name derived by the names of Marc and Rita) as a shelter for the poor and needy. She visited the poor in hospitals and used to take them home cooked meals which she herself prepared and what she collected from associates and benefactors.
                        </p>
                        <p style={{ fontSize: isMobile ? '0.95rem' : '1rem' }}>
                            One day a man who was discharged from the hospital who had no place to go and no one to take care of him sought her help and she offered him shelter in the porch of her house and this was the opening of the first "MARCSRI HOME" in 1983.
                        </p>
                        {!isMobile && (
                            <>
                                <p>
                                    With the news of her benevolence and charity spreading around, more and more destitutes started coming in and she never turned them away. Rev. Fr. Julian Tissera who was the then Parish Priest of Katukurunda Kalutara helped her to cope up with the work. He got the youth organization and others to help with the extension facilities to accommodate the inmates who were occupying some cadjan sheds and he helped in several other aspects of even opening several other homes in and around Kalutara area. His untiring and devoted work made him the Chaplain of Marcsri Homes.
                                </p>
                                <p>
                                    Their work blossomed in to various homes, spread throughout the country.
                                </p>
                            </>
                        )}
                    </div>

                    <div className={`${isMobile ? 'col-12 mb-4' : 'col-md-6'}`}>
                        <img
                            src={aboutImage}
                            alt="About Marcsri Homes"
                            className="img-fluid rounded"
                            style={{
                                maxHeight: isMobile ? '500px' : '550px',
                                objectFit: 'cover',
                                width: isMobile ? '100%' : 'auto'
                            }}
                        />
                    </div>
                </div>

                {/* Second Section: Founders of Marcsri Homes */}
                <div className="row mb-5">
                    <div className="col-12">
                        <h2 className="mb-4 text-center" style={{
                            fontSize: isMobile ? '2em' : isTablet ? '2.5em' : '3em',
                            fontFamily: 'Georgia'
                        }}>
                            Founders of Marcsri Homes
                        </h2>
                    </div>
                    <div className={`${isMobile ? 'col-12 mb-4' : 'col-md-6 mb-md-0'}`}>
                        <div className="text-center">
                            <img
                                src={ritaPereraImage}
                                alt="Mrs. Rita Perera"
                                className="img-fluid rounded shadow"
                                style={{
                                    maxHeight: isMobile ? '300px' : '400px',
                                    objectFit: 'cover',
                                    width: isMobile ? '100%' : 'auto'
                                }}
                            />
                            <p className="mt-3 text-muted" style={{ fontSize: isMobile ? '1rem' : '1.1rem' }}>
                                Mrs. Rita Perera
                            </p>
                            <p className="mt-3 text-muted" style={{ fontSize: isMobile ? '1rem' : '1.1rem' }}>
                                Foundress 1934-2015
                            </p>
                        </div>
                    </div>
                    <div className={`${isMobile ? 'col-12' : 'col-md-6'}`}>
                        <div className="text-center">
                            <img
                                src={julianTisseraImage}
                                alt="Rev. Fr. Julian Tissera"
                                className="img-fluid rounded shadow"
                                style={{
                                    maxHeight: isMobile ? '350px' : '400px',
                                    objectFit: 'cover',
                                    width: isMobile ? '100%' : 'auto'
                                }}
                            />
                            <p className="mt-3 text-muted" style={{ fontSize: isMobile ? '1rem' : '1.1rem' }}>
                                Rev. Fr. Julian Tissera
                            </p>
                            <p className="mt-3 text-muted" style={{ fontSize: isMobile ? '1rem' : '1.1rem' }}>
                                Co-Founder/Director 1947-2017
                            </p>
                        </div>
                    </div>
                </div>

                {/* New Section: Rev. Fr Rector's Message */}
                <div className="row mb-5">
                    <div className="col-12">
                        <h2 className="mb-4 text-center" style={{
                            fontSize: isMobile ? '2em' : isTablet ? '2.5em' : '3em',
                            fontFamily: 'Georgia'
                        }}>
                            Director's Message
                        </h2>
                    </div>

                    {/* Image (Always at the top in mobile) */}
                    <div className="col-12 mb-4">
                        <div className="text-center">
                            <img
                                src={judePereraImage}
                                alt="Rev. Fr. Jude Chrishman Perera"
                                className="img-fluid rounded shadow"
                                style={{
                                    maxHeight: isMobile ? '300px' : '500px',
                                    objectFit: 'cover',
                                    width: isMobile ? '100%' : 'auto'
                                }}
                            />
                            <p className="mt-3 text-muted" style={{ fontSize: isMobile ? '1rem' : '1.1rem' }}>
                                Rev. Fr. Jude Chrishman Perera
                            </p>
                        </div>
                    </div>

                    {/* Message (Below image in mobile, beside in desktop) */}
                    <div className="col-12 text-start">
                        <p className="text-muted mb-4" style={{
                            lineHeight: '1.8',
                            fontSize: isMobile ? '0.95rem' : '1.1rem'
                        }}>
                            Marcsri Homes continues to uphold the legacy of compassion and care established by our founders. Under the guidance of the Archbishop of Colombo, we remain committed to providing shelter and support to the most vulnerable in our society. Our mission is to offer not just a place to stay, but a family environment where every individual feels valued and loved.
                        </p>
                        <p className="text-muted mb-4" style={{
                            lineHeight: '1.8',
                            fontSize: isMobile ? '0.95rem' : '1.1rem'
                        }}>
                            As the Rector, I am deeply honored to serve the residents of Marcsri Homes and work alongside our dedicated staff and volunteers. We strive to expand our outreach, ensuring that more individuals can benefit from the love and care we provide. Our homes are a testament to the power of community and the enduring impact of selfless service.
                        </p>
                        {!isMobile && (
                            <p className="text-muted mb-4" style={{
                                lineHeight: '1.8',
                                fontSize: isMobile ? '0.95rem' : '1.1rem'
                            }}>
                                I invite you to join us in this noble mission, whether through volunteering, donations, or simply spreading awareness of our work. Together, we can continue to make a meaningful difference in the lives of those who need it most, carrying forward the vision of Mrs. Rita Perera and Rev. Fr. Julian Tissera.
                            </p>
                        )}
                    </div>
                </div>

                {/* Third Section: Government Approval Letter */}
                <div className="row mb-5">
                    <div className="col-12">
                        <h2 className="mb-4 text-center" style={{
                            fontSize: isMobile ? '2em' : isTablet ? '2.5em' : '3em',
                            fontFamily: 'Georgia'
                        }}>
                            Government Approval Letter
                        </h2>
                        <img
                            src={approvalLetterImage}
                            alt="Government Approval Letter"
                            className="img-fluid rounded mx-auto d-block"
                            style={{
                                maxHeight: isMobile ? '400px' : '600px',
                                objectFit: 'contain',
                                width: isMobile ? '100%' : 'auto'
                            }}
                        />
                    </div>
                </div>

                {/* Fourth Section: Timeline Carousel */}
                <div className="row mb-5" style={{ marginBottom: isMobile ? '10px' : '20px' }}>
                    <div className="col-12">
                        <div id="timelineCarousel" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                {timelineData.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`carousel-item ${index === activeIndex ? 'active' : ''}`}
                                        style={{ transition: 'opacity 0.5s ease-in-out' }}
                                    >
                                        <div className="d-flex justify-content-center align-items-center position-relative">
                                            <div
                                                className="card text-dark bg-light border-0 shadow-lg"
                                                style={{
                                                    backgroundColor: '#f8f9fa',
                                                    width: isMobile ? '100%' : isTablet ? '80%' : '60%',
                                                    margin: '0 auto',
                                                    borderRadius: '15px',
                                                    borderLeft: '5px solid #28a745',
                                                    transition: 'transform 0.3s ease',
                                                }}
                                                onMouseEnter={(e) => (e.target.style.transform = 'scale(1.02)')}
                                                onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                                            >
                                                <div className={`card-body text-start ${isMobile ? 'p-3' : 'p-5'}`}>
                                                    <h3
                                                        className="card-title text-dark mb-3 fw-bold"
                                                        style={{
                                                            fontSize: isMobile ? '1.5rem' : '2rem',
                                                            color: '#2a3f54'
                                                        }}
                                                    >
                                                        {item.year}
                                                    </h3>
                                                    <p
                                                        className="card-text text-muted"
                                                        style={{
                                                            lineHeight: '1.7',
                                                            fontSize: isMobile ? '0.9rem' : '1.1rem'
                                                        }}
                                                    >
                                                        {item.text}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="carousel-indicators mt-4">
                                {timelineData.map((_, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        data-bs-target="#timelineCarousel"
                                        data-bs-slide-to={index}
                                        className={index === activeIndex ? 'active' : ''}
                                        aria-current={index === activeIndex ? 'true' : 'false'}
                                        aria-label={`Slide ${index + 1}`}
                                        style={{
                                            width: '14px',
                                            height: '14px',
                                            borderRadius: '50%',
                                            backgroundColor: index === activeIndex ? '#28a745' : '#ccc',
                                            border: 'none',
                                            margin: '0 6px',
                                            transition: 'background-color 0.3s ease, transform 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => (e.target.style.transform = 'scale(1.2)')}
                                        onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                                    ></button>
                                ))}
                            </div>
                        </div>
                        {isMobile && (
                            <div className="d-flex justify-content-center mt-3">
                                <button
                                    className="btn btn-success mx-2"
                                    onClick={handlePrev}
                                    style={{
                                        borderRadius: '50%',
                                        width: '40px',
                                        height: '40px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    &lt;
                                </button>
                                <button
                                    className="btn btn-success mx-2"
                                    onClick={handleNext}
                                    style={{
                                        borderRadius: '50%',
                                        width: '40px',
                                        height: '40px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    &gt;
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                {/* Fifth Section: Our Services */}
                <div className={`row mb-5 align-items-center ${isMobile ? 'flex-column-reverse' : ''}`}
                    style={{ marginTop: isMobile ? '20px' : '40px' }}>
                    <div className={`${isMobile ? 'col-12 mt-3' : 'col-md-6'}`}>
                        <img
                            src={servicesImage}
                            alt="Our Services"
                            className="img-fluid rounded shadow-lg"
                            style={{
                                maxHeight: isMobile ? '300px' : '500px',
                                objectFit: 'cover',
                                transition: 'transform 0.3s ease',
                                width: isMobile ? '100%' : 'auto'
                            }}
                            onMouseEnter={(e) => (e.target.style.transform = 'scale(1.02)')}
                            onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                        />
                    </div>

                    <div className={`${isMobile ? 'col-12' : 'col-md-6'} text-start`}>
                        <h2 className="mb-4 fw-bold text-dark" style={{
                            fontSize: isMobile ? '1.8rem' : isTablet ? '2.2rem' : '3rem',
                            letterSpacing: '1px',
                            fontFamily: 'Georgia'
                        }}>
                            Our Services
                        </h2>
                        <p className="text-muted mb-4" style={{
                            lineHeight: '1.8',
                            fontSize: isMobile ? '0.95rem' : '1.1rem'
                        }}>
                            Marcsri Homes offers shelter, compassion and a family to about 270 poor and abandoned across 10 homes all over the country.
                        </p>
                        <div className={`d-flex ${isMobile ? 'flex-column' : 'gap-3'}`}>
                            <Link to="/contact-us" style={{ textDecoration: 'none' }}>
                                <button
                                    className={`btn btn-success text-uppercase ${isMobile ? 'mb-3' : ''}`}
                                    style={{
                                        borderRadius: '8px',
                                        padding: isMobile ? '10px 20px' : '12px 24px',
                                        fontWeight: '500',
                                        transition: 'background-color 0.3s ease, transform 0.3s ease',
                                        width: isMobile ? '100%' : 'auto'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#218838';
                                        e.target.style.transform = 'scale(1.05)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#28a745';
                                        e.target.style.transform = 'scale(1)';
                                    }}
                                >
                                    Donate Now
                                </button>
                            </Link>

                            <Link to="/volunteers" style={{ textDecoration: 'none' }}>
                                <button
                                    className="btn btn-outline-secondary text-uppercase"
                                    style={{
                                        borderRadius: '8px',
                                        padding: isMobile ? '10px 20px' : '12px 24px',
                                        fontWeight: '500',
                                        transition: 'background-color 0.3s ease, transform 0.3s ease, color 0.3s ease',
                                        width: isMobile ? '100%' : 'auto'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#6c757d';
                                        e.target.style.color = '#fff';
                                        e.target.style.transform = 'scale(1.05)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                        e.target.style.transform = 'scale(1)';
                                    }}
                                >
                                    Be a Volunteer
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;